__turbopack_context__.v({
  "bodyTextStyles": "stickycta-module-scss-module__RrC3iG__bodyTextStyles",
  "ctaButtonStyles": "stickycta-module-scss-module__RrC3iG__ctaButtonStyles",
  "displayButton": "stickycta-module-scss-module__RrC3iG__displayButton",
  "hideOnMobile": "stickycta-module-scss-module__RrC3iG__hideOnMobile",
  "imagesWrapperStyles": "stickycta-module-scss-module__RrC3iG__imagesWrapperStyles",
  "mainWrapperStyles": "stickycta-module-scss-module__RrC3iG__mainWrapperStyles",
  "qrCodeStyles": "stickycta-module-scss-module__RrC3iG__qrCodeStyles",
  "staticImageStyles": "stickycta-module-scss-module__RrC3iG__staticImageStyles",
});
